import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaRulemrmrule_1.mjs'
import FormChoose from './FormChooseRulemrmrule_1.jsx'
import TableChoose from './TableChooseRulemrmrule_1.jsx'
import api from './apiRulemrmrule_1.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
